/* eslint-disable */
import { applyMiddleware, compose, createStore } from 'redux';
import thunk from 'redux-thunk';
import { browserHistory } from 'react-router';
import makeRootReducer from './reducers';
import { updateLocation } from './location';
import {createLogger} from 'redux-logger'
import { actions as idleActions } from './redux-idle-monitor'
import { middleware as idleMiddleWare } from './redux-idle-monitor'
import config from '../../config';
import adapter from '@flopflip/launchdarkly-adapter';
import { createFlopFlipEnhancer } from '@flopflip/react-redux';
import createSagaMiddleware from 'redux-saga'
import { rootSaga } from '../common/sagas/index';

const defaultFlags = { };
const adapterArgs = {
  clientSideId: config.ldId,
  user: { key: '0' },
  defaultFlags,
};

export default (initialState = {}) => {

  // ======================================================
  // Logger Configuration
  // ======================================================

  // need to update to ignore repetitive actions (i.e. description input)
  const logger = createLogger({
    logErrors : true,
    predicate : (getState, action) => !action.type.includes('IDLE'),
    collapsed: (getState, action, logEntry) => !logEntry.error

  });

  // ======================================================
  // Middleware Configuration
  // ======================================================
  const sagaMiddleware = createSagaMiddleware()
  const middleware = [thunk, sagaMiddleware];

  // ======================================================
  // Store Enhancers
  // ======================================================
  const enhancers = [
    createFlopFlipEnhancer(adapter, adapterArgs)
  ];

  let composeEnhancers = compose;

  if(!__PROD__) {
    middleware.push(logger)
  }

  if (__DEV__) {
    // middleware.push(logger);
    const composeWithDevToolsExtension = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
      actionsBlacklist: ['IDLE']
    }) : null;
    if (typeof composeWithDevToolsExtension === 'function') {
      composeEnhancers = composeWithDevToolsExtension;
    }
  }

  // ======================================================
  // Store Instantiation and HMR Setup
  // ======================================================
  const store = createStore(
    makeRootReducer(),
    initialState,
    composeEnhancers(
      applyMiddleware(...middleware, idleMiddleWare),
      ...enhancers
    )
  );
  sagaMiddleware.run(rootSaga)
  store.asyncReducers = {};

  // To unsubscribe, invoke `store.unsubscribeHistory()` anytime
  store.unsubscribeHistory = browserHistory.listen(updateLocation(store));

  if (module.hot) {
    module.hot.accept('./reducers', () => {
      const reducers = require('./reducers').default;
      store.replaceReducer(reducers(store.asyncReducers));
    });
  }

  const appState = store.getState().app;
  let refreshed = appState.appRefreshed;
  let authenticated = appState.authenticated;

  store.subscribe(() => {
    const previousRefreshStatus = refreshed;
    const previousAuthStatus = authenticated;

    let state = store.getState();
    refreshed = state.app && state.app.appRefreshed;
    authenticated = state.app && state.app.authenticated;

    // Check a combo of authenticated and page refresh scenarios.
    // We have to check if there was a change, hence all the wackyness
    // of this. Sorry.
    if (refreshed !== previousRefreshStatus && state.app.authenticated) {
      store.dispatch((idleActions.start)())
    }
    if (previousAuthStatus !== authenticated && !state.app.authenticated) {
      store.dispatch((idleActions.stop)())
    }
    if (previousAuthStatus !== authenticated && state.app.authenticated) {
      store.dispatch((idleActions.start)())
    }
  });

  return store;
};



// WEBPACK FOOTER //
// ./src/store/createStore.js